import HeroImage from '../images/hero.png';

const Hero = () => {
  return (
    <section className="relative h-[50vh] md:h-[70vh] overflow-hidden" id="hero">
  <div 
    className="absolute inset-0 bg-cover bg-center bg-fixed animate-kenburns"
    style={{ 
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${HeroImage})`
    }}
  ></div>
  
  <div className="relative h-full flex items-center justify-start text-left px-4 z-10">
    <div className="text-white max-w-4xl pl-4 md:pl-8">
      <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">Empowering Agriculture</h2>
      <p className="text-lg md:text-2xl mb-4 md:mb-6">Let's Trade Africa is your trusted partner</p>
      <p className="text-base md:text-xl font-medium">in Premium Commodity Trading</p>
    </div>
  </div>
</section>

  );
};

export default Hero;
